export default __webpack_public_path__ + "static/media/ic2.159be013.svg";